import { useContext } from 'react';
import { ChatMessagesContext } from '../context/ChatMessagesContext';
/**
 * Custom hook to access the chat messages context.
 * @throws Error if used outside of a MessageProvider
 * @returns The chat messages context
 * @public
 */
export const useChatMessagesContext = () => {
  const context = useContext(ChatMessagesContext);
  if (!context) {
    throw new Error('useMessageContext must be used within a MessageProvider');
  }
  return context;
};